function finiteNumber(value) {
    if (typeof value !== 'number' && (typeof value !== 'string' || !value.trim())) return null;
    return Number.isFinite(Number(value)) ? Number(value) : null;
}

export function stockState(product, quantity = 0, projected = false) {
    const tracked = product && [true, 1, '1', 'true'].includes(product.canStock);
    if (!tracked || product.type === 'VARIABLE' || String(product.id).startsWith('V-')) return null;
    const level = finiteNumber(product.stockLevel);
    if (level === null) return null;
    const threshold = finiteNumber(product.stockThreshold);
    const count = finiteNumber(quantity);
    const remaining = level - (projected && count !== null && count > 0 ? count : 0);
    const color = projected && (count === null || count <= 0) ? null
        : remaining <= 0 ? 'red'
        : threshold !== null && remaining <= threshold ? 'yellow' : null;
    return { level, threshold, remaining, color };
}
